export type BenefitCardTemplateProps = {
  icon: string;
  title: string;
  description: string;
  onClick?: () => void;
};

export const BenefitCardTemplate = ({
  icon,
  title,
  description,
  onClick
}: BenefitCardTemplateProps): JSX.Element => {
  return (
    <div 
      className={`text-center p-6 rounded-lg border border-gray-200 bg-white ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      {icon ? (
        <div className="w-full flex justify-center mb-4">
          <div className="relative w-28 h-28 flex items-center justify-center">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-20 h-20 rounded-full border-2 border-primary-mediumish" />
            </div>
            <img
              src={icon}
              alt={title}
              className="relative z-10 w-14 h-14 object-contain"
            />
          </div>
        </div>
      ) : null}
      <h3 className="text-xl font-semibold mb-2 text-gray-900">{title}</h3>
      <p className="text-gray-500 leading-relaxed">{description}</p>
    </div>
  );
}; 
